import {
  Column,
  Columns,
  Icon,
  IconButton,
  Text,
} from '@dixa/lib-shared-habla';
import { useState } from 'react';
// eslint-disable-next-line no-restricted-imports
import { Outlet, useNavigate } from 'react-router-dom';

import styles from './tvDashboard.view.module.scss';

export type TvDashboardViewOutletContext = {
  setTitle: (title: string) => void;
};

export const TvDashboardView = (): JSX.Element => {
  const navigate = useNavigate();

  const [title, setTitle] = useState('');

  return (
    <Columns>
      <Column className={styles.root}>
        <Column.Row slottable className={styles.header}>
          <Column.Slot placement="start">
            <IconButton
              icon="arrow-left"
              variant="tertiary"
              onClick={() => navigate(-1)}
            />
          </Column.Slot>

          <Column.Slot placement="center">
            <Icon name="dixa" size={24} color="white" />
          </Column.Slot>

          <Column.Slot placement="end">
            {title && (
              <Text.Heading variant="heading-2" color="tertiary">
                {title}
              </Text.Heading>
            )}
          </Column.Slot>
        </Column.Row>

        <Column.Row
          scrollable
          noVerticalPadding
          noHorizontalPadding
          className={styles.main}
        >
          <Outlet
            context={{ setTitle } satisfies TvDashboardViewOutletContext}
          />
        </Column.Row>
      </Column>
    </Columns>
  );
};
